import { Injectable } from '@angular/core';
import { Observable, catchError, delay, from, iif, of, tap } from 'rxjs';

import { IGetParamsResp, IParamsObj } from 'uInterfaces/params';
import { ApiService } from 'uServices/api.service';
import { CacheService } from 'uServices/cache.service';
import { Constants } from 'uApp/app.constants';
import { FakeService } from 'uServices/fake.service';
import { UtilsService } from 'uServices/utils.service';

@Injectable({
  providedIn: 'root'
})
export class ParamsService {
  public fakeOn!: boolean;
  private mobParams!: IParamsObj;

  constructor(private api: ApiService,
              private cache: CacheService,
              private fakeSrv: FakeService,
              private utils: UtilsService) {
    this.fakeOn = Constants.FAKE_DATA_ON;
  }

  public initParams(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      this.getParamsAPI(false, true).subscribe({
        next: (response: IParamsObj) => {
          this.cache.setData('mobParams', response);
          // console.log('ParamsService: initParams result:', this.mobParams);
          resolve(true);
        },
        error: error => {
          console.log('ParamsService: initParams error:', error);
          resolve(false);
        }
      });
    });
  }

  public getParams(refresh: boolean = false, fake: any = undefined): Observable<IParamsObj> {
    return new Observable(observer => {
      // console.log('ParamsService: getParams - present mobParams:', this.mobParams);
      if (refresh || !this.checkEmptyParams()) {
        this.getParamsAPI(false, fake)
          .subscribe({next: response => {
              observer.next(response);
              observer.complete();
            },
            error: error => observer.error(error)});
      } else {
        observer.next(this.mobParams);
        observer.complete();
      }
    });
  }

  public getParamsPr(refresh = false): Promise<IParamsObj | null> {
    return new Promise<IParamsObj | null>((resolve) => {
      if (refresh || !this.checkEmptyParams()) {
        this.getParamsAPI(false, true)
          .subscribe({next: response => resolve(response),
            error: error => resolve(null)});
      } else {
        resolve(this.mobParams);
      }
    });
  }

  private checkEmptyParams() {
    let num = 0;
    for (const key in this.mobParams) {
      if (this.mobParams.hasOwnProperty(key)) { num++; }
    }
    return !!num;
  }

  public getParam(name: string): Observable<string | any> {
    return new Observable(observer => {
      if (this.mobParams && this.mobParams[name]) {  // this.mobParams.length === 0 ||
        observer.next(this.mobParams[name]);
        observer.complete();
      } else {
        this.getParamsAPI(false, true)
          .subscribe({next: response => {
              if (this.mobParams && this.mobParams[name]) {
                observer.next(this.mobParams[name]);
                observer.complete();
              } else {
                observer.error(false);
              }
            },
            error: error => observer.error(error)});
      }
    });
  }

  public getParamSimple(name: string) {
    return this.mobParams && this.mobParams[name];
  }

  private getParamsAPI(spinner = false, fake: any = undefined): Observable<IParamsObj | any> {
    return new Observable<IParamsObj | any>(observer => {
      const request: any = { body: {} };
      const method = Constants.API_METHOD_PARAMETERS;
      request.body[method] = {};

      // ===========  for fake ===========
      // let fake = this.fakeOn;
      fake = fake ?? this.fakeOn;
      // fake = false;

      const mapFake = (response: any) => iif(() => fake,
        from(this.fakeSrv.getFakeData('getParams')).pipe(delay(1000)), response);

      this.api.runRequest({
        method: Constants.API_URL_PARAMETERS, request, spinner,
        includeToken: false, includeSystem: false, showError: false
      }).pipe(
        catchError(error => of(error)),
        mapFake
      ).subscribe((response: IGetParamsResp | any) => {
        console.log('ParamsService: getParamsAPI response:', response);
        // if (spinner) { this.spinner.hideSpinner(); }
        if (response && response.hasOwnProperty(method) && response[method].error.errorCode === '0') {
          const params: IParamsObj | any = response[method];
          delete params.error;
          this.sanitizeParams(params);
          this.mobParams = params;
          observer.next(params);
          observer.complete();
        } else {
          observer.error(false);
        }
      });
    });
  }

  private sanitizeParams(data: IParamsObj) {
    data.callCenter.shiftHour = this.utils.sanitizeSiebelArray(data.callCenter.shiftHour);
  }
}
